<template>
  <div>
    <v-form class="form">
      <v-layout row>
        <v-flex xs5 sm5>
          <v-card class="input">
            <content-editor
              label="Page title"
              v-model="formData.title"
              @input="$v.formData.title.$touch()"
              @blur="$v.formData.title.$touch()"
              :error="$v.formData.title"
            />
          </v-card>
        </v-flex>
        <v-flex xs5 sm5 offset-sm1>
          <v-card class="input">
            <content-editor
              label="Page subtitle"
              v-model="formData.subTitle"
              @input="$v.formData.subTitle.$touch()"
              @blur="$v.formData.subTitle.$touch()"
              :error="$v.formData.subTitle"
            />
          </v-card>
        </v-flex>
      </v-layout>
      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="$v.$invalid || !isWriteAvailable"
      >Update settings
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import mixins from '@/utils/mixins'
import { path } from 'ramda'

export default {
  name: 'FAFormSettings',
  mixins: [mixins.isWriteAvailable],
  data() {
    return {
      formData: {
        id: '',
        title: '',
        subTitle: ''
      },
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'registration:write'
    }
  },
  computed: {
    ...mapGetters(['getSettings']),
    featuredAttendeePageSettings () {
      return path(['featuredAttendeeSetting'], this.getSettings)
    }
  },
  methods: {
    ...mapActions([
      'fetchFeaturedAttendeePageSettings',
      'updateFeaturedAttendeePageSettings',
      'fetchGeneralSettings'
    ]),
    setFormData () {
      this.formData.id = this.featuredAttendeePageSettings.id || this.formData.id
      this.formData.title = this.featuredAttendeePageSettings.title || this.formData.title
      this.formData.subTitle = this.featuredAttendeePageSettings.subTitle || this.formData.subTitle
    },
    async submitForm () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      await this.updateFeaturedAttendeePageSettings(this.formData)
      await this.fetchGeneralSettings()
      this.setFormData()
    }
  },
  async created () {
    if (!this.getSettings) {
      await this.fetchGeneralSettings()
    }
    this.setFormData()
  },
  validations: {
    formData: {
      title: { required },
      subTitle: { required }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 35px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/FeatureAttendee/FAPageSettings.vue